// Phone menu drawer: only one section open at a time (Gina, Oct 16).
document.addEventListener(
  'toggle',
  (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
    const drawer = opened.closest('.menu-drawer');
    if (!drawer) return;
    for (const other of drawer.querySelectorAll('details[open]')) {
      if (other !== opened && !other.contains(opened) && !opened.contains(other)) {
        other.querySelector('summary')?.click();
      }
    }
  },
  true
);
